import './Paragraph.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var paragraph = _7a468({defaultClassName:'_487p2n0-3-15-1',variantClassNames:{ellipsis:{singleLine:'_487p2n1-3-15-1',multiLine:'_487p2n2-3-15-1'}},defaultVariants:{},compoundVariants:[]});